import { Action } from 'redux'
import { notification } from 'antd'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditMeetingPayload } from '@app-store/slices/eventSettings/editMeeting'

interface TaskAction extends Action {
    payload: IEditMeetingPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.eventSetting.editMeeting

function* editMeetingSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.put(`/event/settings/${payload.settingId}/meeting-setting`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Meeting setting updated successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editMeetingSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editMeetingSagaTask)
}

export default editMeetingSaga
